import CursorActionTypes from "./cursor.types";

export const updateCursorType = (cursorType) => ({
  type: CursorActionTypes.UPDATE_CURSOR_TYPE,
  payload: cursorType,
});
